const Builder = require('./BuilderBase');
const ShortText = require('./formElements/ShortText');
const CustomizableVisibility = require('./CustomizableVisibility');

module.exports = class ImportForm extends Builder {
    constructor(title, properties) {
        super('actionElement_ImportForm', title, properties);
    }
    shortText(title, properties) {
        let shortText = new ShortText(title, properties);
        this.addChildBlock(shortText);
        return shortText;
    }

    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} properties.isTabAccess
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility(properties);
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }
};
